import GlobalVariables from "./globalVariables";

const ASK_ADDY_ANSWER = "ask-addy-answer";
// The backend keeps a snapshot of what was rated; the answer can be long.
const MAX_SNAPSHOT_CHARS = 8000;

/**
 * A thumbs down on an Ask Addy answer, sent where processing checklist feedback goes
 * (POST /task-feedback/submit): saved with the rest and emailed to the team that reads it.
 */
export const submitAnswerFeedback = async ({ userId, organizationId, loanId, threadId, turn, question, answer, reason }) => {
  const response = await fetch(`${GlobalVariables.getAPIURL()}/api/task-feedback/submit`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      uid: userId,
      organizationId,
      ...(loanId ? { loanId } : {}),
      entityType: ASK_ADDY_ANSWER,
      taskId: `${threadId}#${turn}`,
      taskTitle: (question || "Ask Addy answer").slice(0, MAX_SNAPSHOT_CHARS),
      taskResult: (answer || "").slice(0, MAX_SNAPSHOT_CHARS),
      positive: false,
      reason,
    }),
  });
  const body = await response.json().catch(() => ({}));
  if (!response.ok || body.success === false) throw new Error(body.reason || `HTTP ${response.status}`);
};
